<template>
    <div>
      <!-- 头部 -->
      <top></top>
      <div class="main">
        <navMenu :active="active"></navMenu>
        <div class="content content-type" v-loading.fullscreen.lock="loading">
          <div class="main-title pd">酒店预定</div>
          <div  v-if="detail.deadline" class="main-sub pd">提交截止日期：{{ detail.deadline }}</div>
          <!-- <div class="main-title pd">{{ content.menu_title }}</div> -->
          <!-- <div class="main-sub pd" v-if="list[0].menu_mark == 'scheme'" v-html="content.title_brief"></div>
          <div class="main-sub pd" v-if="list[0].menu_mark == 'space'" v-html="content.title_brief_1"></div> -->
          <div class="template-main pd">
            <div class="template-left" v-if="list.length > 0">
              <div
                class="t_item"
                v-for="(item, index) in list"
                :key="index"
                @click="toList(item.link_url,item.mark,item.link_type)"
              >
                <div
                  class="template-item"
                  :class="{
                      known:item.is_skip==1&&item.is_verify==0,
                      skip:item.is_skip==1&&item.is_verify==1,
                      next:item.is_skip==0&&item.is_verify==1,
                  }"
                  v-if="item.link_url != ''"
                >
                  <div class="template-top">
                    <el-image
                      class="icon"
                      v-if="item.log"
                      :src="item.log"
                    >
                    </el-image>
                    <span class="title">{{ item.name }}</span>
                  </div>
                  <div v-if="item.deadline" class="tjtime">提交截止日期：{{ item.deadline }}</div>

                  <div class="t-enter flex" >
                    <div class="con-bottom ">
              <div>
                <div class="con-status read" v-if="item.action == 2">已读</div>
                <div class="con-status warning" v-if="item.action == 1">跳过</div>
                <div class="con-status uncompleted" v-if="item.action == 0">未完成</div>
                <div class="con-status warning" v-if="item.action == 3">审核中</div>
                <div class="con-status read" v-if="item.action == 4">已完成</div>
                <!-- <div class="con-status" v-if="item.action == 3">未通过</div> -->
              </div>
                 </div>
                    <div style="margin-top: 10px;">  进入 <i class="el-icon-arrow-right"></i></div>
                  </div>
                </div>
              </div>
              <!-- 展位信息 -->
              <div
                v-if="
                  list[0].menu_mark == 'scheme' || list[0].menu_mark == 'space'
                "
              >
              </div>
            </div>
          </div>
          <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==1">
             <div class="btn" @click="next('skip')">跳过</div>
             <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
           <!-- 可跳过无需验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')">已知悉</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template  v-if="detail.is_skip==0&&detail.is_verify==1">
              <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>
        </div>
      </div>
      <el-dialog

              title=""
              :visible.sync="dialogVisible"
              width="15%"
              :before-close="handleClose">
        <span class="dialog_box">敬请期待！</span>
        <span slot="footer" class="dialog-footer">

    <!--<el-button type="primary" @click="dialogVisible = false" size="medium">确 定</el-button>-->
  </span>
      </el-dialog>
    </div>
</template>
  
  <script>
    import { getDetail, getConfig,skipOrReadStep,getmyMenu } from "@/api/api";
    import top from "../components/top.vue"; //头部
    import navMenu from "../components/navMenu.vue"; //左侧步骤条
    export default {
        components: { top, navMenu },
        name: "reservation",
        data() {
        return {
            dialogVisible:false,
            detail:{},
            loading: false,
            active: 3,
            userInfor: {},
            boothType: "",
            list: [],
            content: {},
            richHtml: "",
            stepJson: {},
            urlList: [],
            height: "",
        };
        },
        mounted() {
        this.getMenu();
        },
        watch: {
        
        },
        methods: {
 
        getMenu() {
      let that=this;
          let data = this.$qs.stringify({type: JSON.parse(localStorage.getItem("userdata")).type});
        getmyMenu(data).then((res) => {
            if (res.code == 1) {
              let { data } = res;
              this.stepMenuList=data;
              let stepMenuList = data;
              var index = stepMenuList.findIndex(function (item) {
                return item.link_url == "/reservation";
              });
              that.detail=stepMenuList[index]
              if(stepMenuList[index].children&&stepMenuList[index].children.length>0){
                that.list=stepMenuList[index].children;  
              }
              that.active = index;
            }
          }).catch((err) => {
            console.log(err);
          });
    }, 
        //  获取内容
        getContent(id) {
            this.loading = true;
            getDetail({ id })
            .then((res) => {
                //console.log(res, "======菜单进度");
                if (res.code == 200) {
                let { data } = res.data;
                this.content = data[0];
                console.log(this.content, '====this.content')
                this.getStepStatus(data[0].menu_mark);
                //获取二级展示信息及二级进度
                this.getConfig(this.id);
                if (data[0].step) {
                    this.content.title_brief = data[0].step.title_brief;
                    this.content.title_brief_1 = data[0].step.title_brief_1;
                    this.richHtml = data[0].step.app_introduction;
                } else {
                    this.richHtml = "";
                }
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        //获取二级进度配置
        getConfig(parent_menu_id) {
            getConfig({ parent_menu_id })
            .then((res) => {
                //console.log(res.data, "======获取二级进度配置");
                this.loading = false;
                if (res.code == 200) {
                let { data } = res.data;
                let newData = [];
                data.forEach((item) => {
                    if (
                    (this.boothType == "1" && item.menu_mark != "space") ||
                    (this.boothType == "2" && item.menu_mark != "scheme")
                    ) {
                    newData.push(item);
                    }
                });
                this.list = newData;
                if (newData[0].menu_mark == "space") {
                    setTimeout(() => {
                    this.height = this.$refs.infor.clientHeight;
                    }, 10);
                }
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
 
        // 跳转页面
        toList(path,mark,link_type) {
           this.dialogVisible=true;
            // if(link_type==2){
            //   window.open(path, "_blank");
            //   this.skipOrReadStep(2,mark)
            // }else{
            //   this.$router.push({
            //     path
            // });
            // }
        },
                       // 跳转下一步
   next(type) {
      if(type=='next'){//下一步
        if(this.detail.action==1||this.detail.action==4){
          this.toPath();
        }else{
            this.$message.warning("请完善信息!")
        }

      }else if(type=='skip'){//跳过
        this.skipOrReadStep(1,this.detail.mark)
      }else if(type=='known'){//已知悉
        this.skipOrReadStep(2,this.detail.mark)
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action,mark){
      let data={
        type:JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark,
      }
      skipOrReadStep(data).then(res=>{
        if(res.code==1){
          this.$message.success("操作成功")
          this.toPath()
        }else{
          this.$message.error(res.data.msg)
        }

      }).catch(err=>{
        console.log(err)
      })

    },
        toPath() {
            this.active = this.active + 1;
            let { link_url, menu_title, id } = this.stepMenuList[this.active];
            this.$router.push({
                path: link_url
            });
        }, 
        },
    };
  </script>
  
  <style lang="scss" scoped>
    /deep/ .el-dialog{
      margin-top: 30vh !important;
    }
    /deep/ .el-dialog__body{
      text-align: center;
    }
    .dialog_box{
      font-size: 18px;
      font-weight: bold;

    }
  .t-enter{
    justify-content: space-between;
  }
   .conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 128px;
    height: 36px;
    cursor: pointer;
    margin: 0 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #CAD2DD;
    border-radius: 9px;
    &:hover {
      text-decoration: underline;
    }
  }
  .next_btn {
    color: #fff;
    background: linear-gradient( 90deg, #F27FC0 0%, #E40080 100%);
    border: none;
  }
}
  .stand-prepare {
    font-size: 20px;
    font-weight: 500;
    color: #2c2c2e;
    line-height: 28px;
    margin: 50px 0 20px;
  }
  .template-main {
   
    .template-left {
      display: flex;
      flex-wrap: wrap;
      background: #fff;
      padding: 10px 0 300px 0px;
      border-radius: 8px;
      box-sizing: border-box;
    }
    .template-right {
      flex: 1;
      // padding: 0 60px;
    }
  }
  // 展商信息
  .ex-infor {
    margin-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 0 none;
    .ex-wrap {
      color: #2c2c2e;
      margin-right: 20px;
      .ex-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        width: 100%;
      }
      .ex-content {
        width: 360px;
        height: auto;
        padding: 23px;
        margin-top: 1px;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 30px;
        box-sizing: border-box;
        background: linear-gradient(90deg, #e4ecfd 0%, #f9fbff 100%);
        border-radius: 18px;
        > div {
          margin-bottom: 13px;
        }
        .ex-tinfor {
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          .ex-left {
            width: 56px;
            height: 20px;
            display: inline-block;
            text-align: justify;
            &:after {
              content: "";
              display: inline-block;
              width: 100%;
            }
          }
          .ex-right {
            flex: 1;
          }
        }
        .mb0 {
          margin-bottom: 0;
        }
      }
    }
  }
  .borderno {
    border-bottom: 0 none;
  }
  .known{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient(90deg, #57CCF1 0%, #2E81EB 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #57CCF1 0%, #2E81EB 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .skip{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient(90deg, #FFDF69 0%, #F7971E 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #FFDF69 0%, #F7971E 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .next{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient( 135deg, #FF99AC 0%, #FF3961 100%);
    
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient( 135deg, #FF99AC 0%, #FF3961 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .template-item {
    color: #fff;
    font-size: 20px;
    position: relative;
    margin-bottom: 30px;
    margin-right: 22px;
    // background: linear-gradient(135deg, #FEB45B 0%, #F2508C 100%, #F24F8D 100%);
    .title {
      flex: 1;
    }
    .sub {
      color: #fff;
      width: 100%;
      font-size: 16px;
      margin-top: 5px;
      font-weight: normal;
    }
    .t-enter {
      color: #fff;
      position: relative;
      z-index: 9;
    }
    > * {
      z-index: 9;
    }
    &:hover {
      color: #fff;
    }
  }
  .tem-pink {
    &::before {
      background: linear-gradient(135deg, #8eb2fd 0%, #be60cb 100%);
    }
    &::after {
      background: linear-gradient(135deg, #71a4ff 0%, #b035bd 100%);
    }
    &:hover::before {
      background: linear-gradient(135deg, #71a4ff 0%, #b035bd 100%);
    }
  }
  .tem-blue {
    &::before {
      background: linear-gradient(135deg, #8ac7f3 0%, #358ece 100%);
    }
    &::after {
      background: linear-gradient(
        135deg,
        #72bdf3 0%,
        #55a9e6 23%,
        #1880cc 75%,
        #0070c2 100%
      );
    }
    &:hover::before {
      background: linear-gradient(
        135deg,
        #72bdf3 0%,
        #55a9e6 23%,
        #1880cc 75%,
        #0070c2 100%
      );
    }
  }
  .tem-green {
    &::before {
      background: linear-gradient(135deg, #32d4b4 0%, #32aba2 100%);
    }
    &::after {
      background: linear-gradient(135deg, #00cba2 0%, #00968b 100%);
    }
    &:hover::before {
      background: linear-gradient(135deg, #00cba2 0%, #00968b 100%);
    }
  }
  .rich-text /deep/ img {
    max-width: 100%;
  }
  .rich-text {
    height: 500px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0px;
      height: 5px;
    }
    // &::-webkit-scrollbar-track-piece {
    //   background-color: rgba(0, 0, 0, 0.1);
    //   -webkit-border-radius: 6px;
    // }
    // &::-webkit-scrollbar-thumb:vertical {
    //   height: 5px;
    //   background-color: rgba(125, 125, 125, 0.3);
    //   -webkit-border-radius: 6px;
    // }
    // &::-webkit-scrollbar-thumb:horizontal {
    //   width: 5px;
    //   background-color: rgba(125, 125, 125, 0.3);
    //   -webkit-border-radius: 6px;
    // }
  }
  .booth-infor {
    .booth-div {
      font-size: 18px;
      color: #ccc;
      line-height: 25px;
      margin-bottom: 20px;
      .booth-left {
        width: 74px;
        height: 25px;
        color: #2c2c2e;
        margin-bottom: 10px;
      }
      .booth-right {
        .booth-imgwrap {
          width: 100%;
          max-width: 862px;
          margin-bottom: 20px;
          .booth-image {
            width: 100%;
            border-radius: 10px;
          }
          .booth-text {
            color: #999;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1280px) {
    .template-main .template-left {
      width: 100% !important;
      padding: 30px 0 70px 20px;
  }
  }
  @media only screen and (max-width: 767px) {
    .t_item{
    width: 94%;
  }
    .title{
      font-size: 16px !important;
    }
    .template-item .sub[data-v-2feb20eb] {
      font-size: 12px !important;
    }
    .content{
      // padding: initial !important;
      margin: initial !important;
    }
    .t-enter {
      font-size: 12px !important;
    }
    .el-button{
      font-size: 15px !important;
    }
  .template-left{
    width: 100% !important;
    padding: 30px 0 70px 0;
  }
  .template-item{
    width: 100% !important;
  }
    .template-right{
      padding: initial !important;
    }
    .template-main {
      margin-top: 10px;
  }
  .rich-text{
    padding: initial !important;
    height: initial !important;
  }
    
   
  }
  </style>